import type { PhoneZone } from "./types.js";

export const phoneZones: Array<PhoneZone> = [
    {
        prefix: 33,
        label: "France",
        emoji: "🇫🇷",
        mask: "0_ __ __ __ __",
        category: "france",
    },
    {
        prefix: 590,
        label: "Guadeloupe",
        emoji: "🇬🇵",
        mask: "0___ __ __ __",
        category: "france",
    },
    {
        prefix: 596,
        label: "Martinique",
        emoji: "🇲🇶",
        mask: "0___ __ __ __",
        category: "france",
    },
    {
        prefix: 594,
        label: "Guyane",
        emoji: "🇬🇫",
        mask: "0___ __ __ __",
        category: "france",
    },
    {
        prefix: 262,
        label: "Réunion",
        emoji: "🇷🇪",
        mask: "0___ __ __ __",
        category: "france",
    },
    {
        prefix: 262,
        label: "Mayotte",
        emoji: "🇾🇹",
        mask: "0___ __ __ __",
        category: "france",
    },
    {
        prefix: 590,
        label: "Saint-Barthélemy",
        emoji: "🇧🇱",
        mask: "0___ __ __ __",
        category: "france",
    },
    {
        prefix: 590,
        label: "Saint-Martin",
        emoji: "🇲🇫",
        mask: "0___ __ __ __",
        category: "france",
    },
    {
        prefix: 508,
        label: "Saint-Pierre-et-Miquelon",
        emoji: "🇵🇲",
        mask: "__ __ __",
        category: "france",
    },
    {
        prefix: 687,
        label: "Nouvelle-Calédonie",
        emoji: "🇳🇨",
        mask: "__ __ __",
        category: "france",
    },
    {
        prefix: 689,
        label: "Polynésie française",
        emoji: "🇵🇫",
        mask: "__ __ __ __",
        category: "france",
    },
    {
        prefix: 681,
        label: "Wallis-et-Futuna",
        emoji: "🇼🇫",
        mask: "__ __ __",
        category: "france",
    },
    {
        prefix: 355,
        label: "Albanie",
        emoji: "🇦🇱",
        mask: "0__ ___ ____",
        category: "europe",
    },
    {
        prefix: 49,
        label: "Allemagne",
        emoji: "🇩🇪",
        mask: "0___ ________",
        category: "europe",
    },
    {
        prefix: 376,
        label: "Andorre",
        emoji: "🇦🇩",
        mask: "___ ___",
        category: "europe",
    },
    {
        prefix: 43,
        label: "Autriche",
        emoji: "🇦🇹",
        mask: "0___ _______",
        category: "europe",
    },
    {
        prefix: 32,
        label: "Belgique",
        emoji: "🇧🇪",
        mask: "0___ __ __ __",
        category: "europe",
    },
    {
        prefix: 375,
        label: "Biélorussie",
        emoji: "🇧🇾",
        mask: "__ ___ __ __",
        category: "europe",
    },
    {
        prefix: 387,
        label: "Bosnie-Herzégovine",
        emoji: "🇧🇦",
        mask: "0__ ___ ___",
        category: "europe",
    },
    {
        prefix: 359,
        label: "Bulgarie",
        emoji: "🇧🇬",
        mask: "0__ ___ ____",
        category: "europe",
    },
    {
        prefix: 357,
        label: "Chypre",
        emoji: "🇨🇾",
        mask: "__ ______",
        category: "europe",
    },
    {
        prefix: 385,
        label: "Croatie",
        emoji: "🇭🇷",
        mask: "0__ ___ ____",
        category: "europe",
    },
    {
        prefix: 45,
        label: "Danemark",
        emoji: "🇩🇰",
        mask: "__ __ __ __",
        category: "europe",
    },
    {
        prefix: 34,
        label: "Espagne",
        emoji: "🇪🇸",
        mask: "___ __ __ __",
        category: "europe",
    },
    {
        prefix: 372,
        label: "Estonie",
        emoji: "🇪🇪",
        mask: "____ ____",
        category: "europe",
    },
    {
        prefix: 358,
        label: "Finlande",
        emoji: "🇫🇮",
        mask: "0__ _______",
        category: "europe",
    },
    {
        prefix: 30,
        label: "Grèce",
        emoji: "🇬🇷",
        mask: "___ ___ ____",
        category: "europe",
    },
    {
        prefix: 36,
        label: "Hongrie",
        emoji: "🇭🇺",
        mask: "06 __ ___ ____",
        category: "europe",
    },
    {
        prefix: 353,
        label: "Irlande",
        emoji: "🇮🇪",
        mask: "0__ ___ ____",
        category: "europe",
    },
    {
        prefix: 354,
        label: "Islande",
        emoji: "🇮🇸",
        mask: "___ ____",
        category: "europe",
    },
    {
        prefix: 39,
        label: "Italie",
        emoji: "🇮🇹",
        mask: "___ ___ ____",
        category: "europe",
    },
    {
        prefix: 383,
        label: "Kosovo",
        emoji: "🇽🇰",
        mask: "0__ ___ ___",
        category: "europe",
    },
    {
        prefix: 371,
        label: "Lettonie",
        emoji: "🇱🇻",
        mask: "__ ___ ___",
        category: "europe",
    },
    {
        prefix: 423,
        label: "Liechtenstein",
        emoji: "🇱🇮",
        mask: "___ ____",
        category: "europe",
    },
    {
        prefix: 370,
        label: "Lituanie",
        emoji: "🇱🇹",
        mask: "0__ ___ ___",
        category: "europe",
    },
    {
        prefix: 352,
        label: "Luxembourg",
        emoji: "🇱🇺",
        mask: "___ ___ ___",
        category: "europe",
    },
    {
        prefix: 389,
        label: "Macédoine du Nord",
        emoji: "🇲🇰",
        mask: "0__ ___ ___",
        category: "europe",
    },
    {
        prefix: 356,
        label: "Malte",
        emoji: "🇲🇹",
        mask: "____ ____",
        category: "europe",
    },
    {
        prefix: 373,
        label: "Moldavie",
        emoji: "🇲🇩",
        mask: "0__ ___ ___",
        category: "europe",
    },
    {
        prefix: 377,
        label: "Monaco",
        emoji: "🇲🇨",
        mask: "0_ __ __ __ __",
        category: "europe",
    },
    {
        prefix: 382,
        label: "Monténégro",
        emoji: "🇲🇪",
        mask: "0__ ___ ___",
        category: "europe",
    },
    {
        prefix: 47,
        label: "Norvège",
        emoji: "🇳🇴",
        mask: "___ __ ___",
        category: "europe",
    },
    {
        prefix: 31,
        label: "Pays-Bas",
        emoji: "🇳🇱",
        mask: "0_ ________",
        category: "europe",
    },
    {
        prefix: 48,
        label: "Pologne",
        emoji: "🇵🇱",
        mask: "___ ___ ___",
        category: "europe",
    },
    {
        prefix: 351,
        label: "Portugal",
        emoji: "🇵🇹",
        mask: "___ ___ ___",
        category: "europe",
    },
    {
        prefix: 40,
        label: "Roumanie",
        emoji: "🇷🇴",
        mask: "0___ ___ ___",
        category: "europe",
    },
    {
        prefix: 44,
        label: "Royaume-Uni",
        emoji: "🇬🇧",
        mask: "0____ ______",
        category: "europe",
    },
    {
        prefix: 7,
        label: "Russie",
        emoji: "🇷🇺",
        mask: "___ ___ __ __",
        category: "europe",
    },
    {
        prefix: 378,
        label: "Saint-Marin",
        emoji: "🇸🇲",
        mask: "__ __ __",
        category: "europe",
    },
    {
        prefix: 381,
        label: "Serbie",
        emoji: "🇷🇸",
        mask: "0__ _______",
        category: "europe",
    },
    {
        prefix: 421,
        label: "Slovaquie",
        emoji: "🇸🇰",
        mask: "0___ ___ ___",
        category: "europe",
    },
    {
        prefix: 386,
        label: "Slovénie",
        emoji: "🇸🇮",
        mask: "0__ ___ ___",
        category: "europe",
    },
    {
        prefix: 46,
        label: "Suède",
        emoji: "🇸🇪",
        mask: "0__ ___ __ __",
        category: "europe",
    },
    {
        prefix: 41,
        label: "Suisse",
        emoji: "🇨🇭",
        mask: "0__ ___ __ __",
        category: "europe",
    },
    {
        prefix: 420,
        label: "Tchéquie",
        emoji: "🇨🇿",
        mask: "___ ___ ___",
        category: "europe",
    },
    {
        prefix: 380,
        label: "Ukraine",
        emoji: "🇺🇦",
        mask: "0__ ___ ____",
        category: "europe",
    },
];
